import { FC } from 'react';
import { ShopInternalSettings } from 'containers/shop';
import { ShopInternalLayout } from 'pages/atoms';

const ShopInternalSettingsPage: FC = () => {
  return (
    <ShopInternalLayout>
      <ShopInternalSettings />
    </ShopInternalLayout>
  );
};

export default ShopInternalSettingsPage;
